import { uniqBy } from 'lodash';
import { AllocationScenarioDetailSecurityModel, AllocationScenarioValuationModel } from 'api';
import { filterSecurities, getArrayValue, getObjectValue } from 'utillities';

const getCapTableSecurities = (allocationScenarios: AllocationScenarioValuationModel[]) => {
  const allocationScenariosSecurities = getArrayValue(
    allocationScenarios?.reduce((accumulator, current) => {
      const { cap_table: capTable } = current;
      const { securities: capTableSecurities = [] } = getObjectValue(capTable);

      return [...accumulator, ...filterSecurities(capTableSecurities)];
    }, [] as AllocationScenarioDetailSecurityModel[])
  );

  return getArrayValue(uniqBy(allocationScenariosSecurities, 'name'));
};

export default getCapTableSecurities;
